import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env.local file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database table names (Kankanjali Studio - prefixed to avoid conflicts)
export const TABLES = {
  PHOTOS: 'ks_photos',
  GALLERIES: 'ks_galleries',
  CATEGORIES: 'ks_categories',
  BOOKINGS: 'ks_bookings',
  CONTACTS: 'ks_contacts',
  USER_PROFILES: 'ks_user_profiles',
  OFFERS: 'ks_offers'
}
